import { PageLayout } from 'src/components/Layout/PageLayout'
import Loading from 'src/components/Loading'
import { SEO } from 'src/components/SEO'
import pageServices from 'src/services/page.service'
import { useRouter } from 'next/router'
import BASE_CONFIG from 'src/configs/base'
import moment from 'moment'
import CustomBreadcrumb from 'src/components/CustomBreadcrumb'

const Page = ({ data, seo }) => {
	const router = useRouter()
	if (!data) window.location.href = '/404' // chuyển qua trang 404
	return (
		<div className="static__page">
			{/* <CustomBreadcrumb
						customRoute={[
							{
								breadcrumbName: data.Name,
								breadcrumbSubName: data.Name,
								path: '#',
							},
						]}
					/> */}
			{seo && (
				<SEO
					data={{
						title: seo.Title,
						description: seo.Description,
						thumbnailUrl: seo.ThumbImage,
						keywords: seo.Keyword,
						newsKeywords: seo.Keyword,
						url: seo.Canonical ? seo.Canonical : BASE_CONFIG.PAGE_URL + router.asPath,
						redirect: seo.Redirect ? seo.Redirect : BASE_CONFIG.PAGE_URL + router.asPath,
						publishDate: seo.ScheduleDate
							? seo.ScheduleDate
							: moment().format('YYYY-MM-DD[T]HH:mm:ss'),
					}}
				/>
			)}
			{!data ? (
				<Loading />
			) : (
				<div
					className="container page__container"
					dangerouslySetInnerHTML={{ __html: data.Content }}
				/>
			)}
		</div>
	)
}

export const getServerSideProps = async ({ params }) => {
	const { slug } = params

	const data = await pageServices.getPageBySlug(slug)
	const notFound = !!data
	return {
		props: {
			data: data.Data,
			seo: data.SEO,
			revalidate: 1,
			notFound,
		},
	}
}
// export const getStaticPaths = async () => {
//
// 	const response = await pageServices.getAllPages()
// 	const isDev = process.env.NODE_ENV === 'development'
// 	return {
// 		paths:[],
// 		fallback:false
// 	}
// }

Page.Layout = PageLayout
export default Page
